<template>
  <el-tag
    ref="tag"
    :style="getStylesByTypeAndEffect(type, effect)"
    :type="type"
    :size="size"
    :effect="effect"
    :closable="closable"
  >
    <slot></slot>
  </el-tag>
</template>

<script>
export default {
  name: "l-tag",
  props: {
    size: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    effect: {
      type: String,
      default: "light",
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultTypes: ["success", "danger", "info", "", "warning"],
    };
  },
  methods: {
    getStylesByTypeAndEffect(type, effect) {
      if (this.defaultTypes.includes(this.type)) {
        return {};
      }
      switch (type) {
        case "inuse":
          return {
            color: effect === "dark" ? "#fff" : "#ff99c3",
            backgroundColor:
              effect === "light"
                ? "#ffd6e7"
                : effect === "dark"
                ? "#ff99c3"
                : effect === "plain"
                ? "#fff"
                : "",
            borderColor: "#ff99c3",
          };
        case "pending":
          // 在此处添加 pending 类型的样式逻辑
          return {
            color: effect === "dark" ? "#fff" : "#9270CA", // 替换为实际的 pending 类型颜色值
            backgroundColor:
              effect === "light"
                ? "#F3EFFF"
                : effect === "dark"
                ? "#9270CA"
                : effect === "plain"
                ? "#fff"
                : "", // 替换为实际的 pending 类型背景颜色值
            borderColor: "#9270CA", // 替换为实际的 pending 类型边框颜色值
          };
        default:
          return {};
      }
    },
  },
};
</script>

<style></style>
